export default Object.freeze({
  analytics: {
    componentLocation: 'daydeal',
    pageType: 'daydeal',
    url: 'https://i.daydeal.ch/utag/competec/dealsites/prod/u.js',
    utmSource: 'daydeal',
  },
  basicAuth: {
    enabled: false,
  },
  datadogLogs: {
    clientToken: 'pub9af0d343eb7672723b4159ad226556fe',
    enabled: true,
    sessionSampleRate: 100,
  },
  env: 'prod',
  features: {
    capitalLetters: {
      enabled: false,
      endTime: new Date('2024-10-22T23:59:59'),
      startTime: new Date('2024-10-22T09:00:00'),
    },
    dealPageFullAnimated: {
      enabled: true,
      endTime: new Date('2024-11-29T09:00:00'),
      startTime: new Date('2024-11-28T09:00:00'),
    },
    news: true,
    newsletter: true,
    pastDeals: true,
    promotions: true,
    rebranding: {
      enabled: true,
      startTime: new Date('2026-11-02T08:40:00+01:00'),
    },
    staticPage: true,
  },
  hotjarId: '3516267',
  indexByRobots: true,
  logger: 'sentry',
  metrics: {
    enabled: true,
  },
  parent: {
    name: 'Brack.ch',
    newsletterUrl: 'https://www.brack.ch/newsletter',
    url: 'https://www.brack.ch',
  },
  reCaptcha: {
    siteKey: '6Ld-yY8jAAAAAOemHpt6Xxk-9nX_wCoaMxDMrGew',
  },
  sentry: {
    appId: '6047754',
    publicKey: 'fb80e89e7b1742ef9bae5af0d07fd640',
    sampleRate: 0,
  },
  siteName: 'daydeal',
  tenant: 'Daydeal',
  url: {
    api: {
      broadcast: 'https://broadcast.daydeal.ch',
      comment: 'https://comment.daydeal.ch/api/ui',
      deal: 'https://deal.daydeal.ch/api/ui',
      static: 'https://static.daydeal.ch/api/ui',
    },
    apiSsr: {
      broadcast: 'https://broadcast.int.prod.dd.competec.ninja',
      comment: 'https://comment.int.prod.dd.competec.ninja/api/ui',
      deal: 'https://deal.int.prod.dd.competec.ninja/api/ui',
      static: 'https://static.int.prod.dd.competec.ninja/api/ui',
    },
    cdn: 'https://images.daydeal.ch/files',
    liveMessage: 'wss://live-message.daydeal.ch',
    root: 'https://daydeal.ch',
  },
});
